import ReactDOM from 'react-dom/client';
import App from "./app/layout/app";

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);